/** Message catalogue for features/collections (merged into the global catalogues). Keys: "col.<area>.<name>". */
export const colEn = {
  'col.title': 'collections',
  'col.eyebrow': 'Collection',
  'col.err.required': 'This field is required.',
  'col.err.tooLong': 'This is too long.',
  'col.err.dateOrder': 'End date must be after the start date.',
  'col.vis.PRIVATE': 'Private',
  'col.vis.SHARED': 'Shared',
  'col.vis.PUBLIC': 'Public',
  'col.sort.manual': 'Manual order',
  'col.sort.title': 'Title',
  'col.sort.author': 'Author',
  'col.sort.year': 'Year',
  'col.sort.addedAt': 'Date added',
  'col.lists.title': 'Lists',
  'col.lists.subtitle': 'Reading lists curated by staff and patrons, private, shared by link or public.',
  'col.lists.new': 'New list',
  'col.lists.newTitle': 'New list',
  'col.lists.editTitle': 'Edit list',
  'col.lists.formHint': 'Choose who can see the list and how entries are ordered.',
  'col.lists.name': 'Name',
  'col.lists.description': 'Description',
  'col.lists.visibility': 'Visibility',
  'col.lists.visibilityHint.PRIVATE': 'Only you and staff can see this list.',
  'col.lists.visibilityHint.SHARED': 'Anyone with the share link can open it.',
  'col.lists.visibilityHint.PUBLIC': 'Listed in the public catalogue for everyone.',
  'col.lists.sortField': 'Sort entries by',
  'col.lists.sortHint': 'Manual order lets you drag entries or move them up and down.',
  'col.lists.allowAdds': 'Allow patrons to add records',
  'col.lists.allowAddsHint': 'Patrons who can see the list may add titles to it.',
  'col.lists.saved': 'List saved',
  'col.lists.created': 'List created',
  'col.lists.search': 'Search lists',
  'col.lists.mineOnly': 'My lists only',
  'col.lists.entryCount': 'Entries',
  'col.lists.owner': 'Owner',
  'col.lists.updated': 'Updated',
  'col.lists.linkOn': 'Link on',
  'col.lists.empty': 'No lists yet',
  'col.lists.emptyHint': 'Create a reading list to group titles for a topic, event or course.',
  'col.lists.noMatch': 'No lists match',
  'col.lists.noMatchHint': 'Try a different search or clear the filters.',
  'col.lists.detailTitle': 'List details',
  'col.lists.ownedBy': 'By {owner} · {count} entries',
  'col.lists.exportCsv': 'Export CSV',
  'col.lists.exportIds': 'Export ids',
  'col.lists.exportFailed': 'Export failed',
  'col.lists.deleteConfirm': 'Delete "{name}"?',
  'col.lists.deleteHint': 'The list and its entries are removed. The records stay in the catalogue.',
  'col.lists.deleted': 'List deleted',
  'col.lists.deleteFailed': 'Could not delete the list',
  'col.lists.share': 'Sharing',
  'col.lists.shareLink': 'Share by link',
  'col.lists.shareHint': 'Turn on a link anyone can open without signing in.',
  'col.lists.shareUrl': 'Share link',
  'col.lists.shareFailed': 'Could not change sharing',
  'col.lists.entries': 'Entries',
  'col.lists.addRecord': 'Add a record',
  'col.lists.addRecordPlaceholder': 'Search the catalogue to add a title',
  'col.lists.noRecords': 'No records found',
  'col.lists.added': 'Added "{title}"',
  'col.lists.addFailed': 'Could not add the record',
  'col.lists.noEntries': 'This list is empty',
  'col.lists.noEntriesHint': 'Search the catalogue above to add the first title.',
  'col.lists.sortedBy': 'Entries are sorted by {field}. Switch to manual order in Edit to rearrange them.',
  'col.lists.moveUp': 'Move {title} up',
  'col.lists.moveDown': 'Move {title} down',
  'col.lists.reorderFailed': 'Could not save the new order',
  'col.lists.note': 'Note',
  'col.lists.notePlaceholder': 'Add a note for this title',
  'col.lists.editNote': 'Edit note',
  'col.lists.noteFailed': 'Could not save the note',
  'col.lists.removeEntry': 'Remove {title} from the list',
  'col.lists.removeConfirm': 'Remove "{title}" from this list?',
  'col.lists.removeFailed': 'Could not remove the entry',
  'col.courses.title': 'Course reserves',
  'col.courses.subtitle': 'Put items on reserve for a course with temporary loan rules while it runs.',
  'col.courses.new': 'New course',
  'col.courses.newTitle': 'New course',
  'col.courses.editTitle': 'Edit course',
  'col.courses.detailTitle': 'Course reserve',
  'col.courses.code': 'Code',
  'col.courses.name': 'Course name',
  'col.courses.department': 'Department',
  'col.courses.term': 'Term',
  'col.courses.section': 'Section',
  'col.courses.sectionN': 'Section {n}',
  'col.courses.startDate': 'Start date',
  'col.courses.endDate': 'End date',
  'col.courses.instructors': 'Instructors',
  'col.courses.instructorsHint': 'Search patrons by name or card number.',
  'col.courses.removeInstructor': 'Remove {name}',
  'col.courses.noInstructors': 'No instructors assigned',
  'col.courses.notes': 'Notes',
  'col.courses.enabled': 'Enabled',
  'col.courses.disabled': 'Disabled',
  'col.courses.enabledSwitch': 'Course enabled',
  'col.courses.enabledHint': 'Enabling applies the temporary item settings. Disabling restores the originals.',
  'col.courses.enableCourse': 'Enable course {code}',
  'col.courses.itemCount': 'Items',
  'col.courses.search': 'Search by code, name, department or instructor',
  'col.courses.empty': 'No courses yet',
  'col.courses.emptyHint': 'Create a course, then scan items onto its reserve list.',
  'col.courses.noMatch': 'No courses match',
  'col.courses.noMatchHint': 'Try a different search or clear the filters.',
  'col.courses.saved': 'Course saved',
  'col.courses.created': 'Course created',
  'col.courses.toggleFailed': 'Could not change the course status',
  'col.courses.deleteConfirm': 'Delete course "{name}"?',
  'col.courses.deleteHint': 'Every item it overrode is restored to its original settings.',
  'col.courses.deleted': 'Course deleted',
  'col.courses.deleteFailed': 'Could not delete the course',
  'col.courses.items': 'Reserve items',
  'col.courses.scanLabel': 'Add an item by barcode',
  'col.courses.scanPlaceholder': 'Scan or type an item barcode',
  'col.courses.overridesToggle': 'Temporary settings for the next item',
  'col.courses.overridesHint': 'These apply to the item only while the course is enabled.',
  'col.courses.noOverride': 'Keep current',
  'col.courses.tempType': 'Item type',
  'col.courses.tempLocation': 'Shelving location',
  'col.courses.tempCollection': 'Collection',
  'col.courses.tempLibrary': 'Holding library',
  'col.courses.tempCallNumber': 'Call number',
  'col.courses.staffNote': 'Staff note',
  'col.courses.publicNote': 'Public note',
  'col.courses.itemAdded': 'Put "{title}" on reserve',
  'col.courses.noAuthor': 'No author',
  'col.courses.applied': 'Applied',
  'col.courses.pending': 'Not applied',
  'col.courses.itemOff': 'Off',
  'col.courses.itemEnabled': 'Reserve enabled for {title}',
  'col.courses.editItem': 'Edit temporary settings',
  'col.courses.itemSaveFailed': 'Could not save the item',
  'col.courses.removeItem': 'Take {title} off reserve',
  'col.courses.removeItemConfirm': 'Take "{title}" off reserve?',
  'col.courses.removeItemHint': 'Its original item settings are restored.',
  'col.courses.itemRemoveFailed': 'Could not remove the item',
  'col.courses.noItems': 'Nothing on reserve yet',
  'col.courses.noItemsHint': 'Scan an item barcode above to put it on this course reserve.',
  'col.reviews.title': 'Reviews and tags',
  'col.reviews.subtitle': 'Moderate what patrons write about titles before it appears in the catalogue.',
  'col.reviews.tab': 'Reviews',
  'col.reviews.queue': 'Review moderation queue',
  'col.reviews.status.pending': 'Pending',
  'col.reviews.status.approved': 'Approved',
  'col.reviews.status.rejected': 'Rejected',
  'col.reviews.status.all': 'All',
  'col.reviews.kbdMove': 'move',
  'col.reviews.kbdApprove': 'approve',
  'col.reviews.kbdReject': 'reject',
  'col.reviews.approve': 'Approve',
  'col.reviews.reject': 'Reject',
  'col.reviews.select': 'Select review by {name}',
  'col.reviews.bulk': 'Bulk actions',
  'col.reviews.deleteOne': 'Delete review',
  'col.reviews.deleteConfirm': 'Delete {count} review(s)?',
  'col.reviews.deleteHint': 'This cannot be undone.',
  'col.reviews.queueClear': 'The queue is clear',
  'col.reviews.queueClearHint': 'New patron reviews will appear here for approval.',
  'col.reviews.empty': 'No reviews here',
  'col.reviews.emptyHint': 'Try another status.',
  'col.reviews.done.approve': '{count} review(s) approved',
  'col.reviews.done.reject': '{count} review(s) rejected',
  'col.reviews.done.delete': '{count} review(s) deleted',
  'col.reviews.actionFailed': '{count} review(s) could not be updated',
  'col.tags.tab': 'Tags',
  'col.tags.title': 'Tag moderation',
  'col.tags.term': 'Tag',
  'col.tags.record': 'Record',
  'col.tags.patron': 'Added by',
  'col.tags.created': 'Created',
  'col.tags.visible': 'Visible',
  'col.tags.hidden': 'Hidden',
  'col.tags.hide': 'Hide',
  'col.tags.approveSelected': 'Approve selected',
  'col.tags.search': 'Search tags',
  'col.tags.deleteOne': 'Delete tag {term}',
  'col.tags.deleteConfirm': 'Delete {count} tag(s)?',
  'col.tags.queueClear': 'No tags waiting',
  'col.tags.queueClearHint': 'Tags suggested by patrons appear here for approval.',
  'col.tags.empty': 'No tags found',
  'col.tags.emptyHint': 'Try another filter.',
  'col.tags.done.approve': '{count} tag(s) approved',
  'col.tags.done.reject': '{count} tag(s) hidden',
  'col.tags.done.delete': '{count} tag(s) deleted',
  'col.tags.actionFailed': '{count} tag(s) could not be updated',
  'col.tags.cloud': 'Public tag cloud',
  'col.tags.cloudHint': 'Approved tags as patrons see them. Larger means more used.',
  'col.tags.cloudEmpty': 'No approved tags yet',
  'col.tags.cloudCount': 'Used {count} time(s)',
} as const;

export const colHi: Record<keyof typeof colEn, string> = {
  'col.title': 'संग्रह',
  'col.eyebrow': 'संग्रह',
  'col.err.required': 'यह फ़ील्ड आवश्यक है।',
  'col.err.tooLong': 'यह बहुत लंबा है।',
  'col.err.dateOrder': 'समाप्ति तिथि प्रारंभ तिथि के बाद होनी चाहिए।',
  'col.vis.PRIVATE': 'निजी',
  'col.vis.SHARED': 'साझा',
  'col.vis.PUBLIC': 'सार्वजनिक',
  'col.sort.manual': 'मैन्युअल क्रम',
  'col.sort.title': 'शीर्षक',
  'col.sort.author': 'लेखक',
  'col.sort.year': 'वर्ष',
  'col.sort.addedAt': 'जोड़ने की तिथि',
  'col.lists.title': 'सूचियाँ',
  'col.lists.subtitle': 'स्टाफ़ और सदस्यों की बनाई पठन सूचियाँ: निजी, लिंक से साझा या सार्वजनिक।',
  'col.lists.new': 'नई सूची',
  'col.lists.newTitle': 'नई सूची',
  'col.lists.editTitle': 'सूची संपादित करें',
  'col.lists.formHint': 'चुनें कि सूची कौन देख सकता है और प्रविष्टियाँ किस क्रम में हों।',
  'col.lists.name': 'नाम',
  'col.lists.description': 'विवरण',
  'col.lists.visibility': 'दृश्यता',
  'col.lists.visibilityHint.PRIVATE': 'यह सूची केवल आप और स्टाफ़ देख सकते हैं।',
  'col.lists.visibilityHint.SHARED': 'शेयर लिंक वाला कोई भी इसे खोल सकता है।',
  'col.lists.visibilityHint.PUBLIC': 'सभी के लिए सार्वजनिक कैटलॉग में सूचीबद्ध।',
  'col.lists.sortField': 'प्रविष्टियाँ इस आधार पर क्रमित करें',
  'col.lists.sortHint': 'मैन्युअल क्रम में आप प्रविष्टियाँ खींच या ऊपर-नीचे कर सकते हैं।',
  'col.lists.allowAdds': 'सदस्यों को रिकॉर्ड जोड़ने दें',
  'col.lists.allowAddsHint': 'सूची देख सकने वाले सदस्य इसमें शीर्षक जोड़ सकते हैं।',
  'col.lists.saved': 'सूची सहेजी गई',
  'col.lists.created': 'सूची बनाई गई',
  'col.lists.search': 'सूचियाँ खोजें',
  'col.lists.mineOnly': 'केवल मेरी सूचियाँ',
  'col.lists.entryCount': 'प्रविष्टियाँ',
  'col.lists.owner': 'स्वामी',
  'col.lists.updated': 'अद्यतन',
  'col.lists.linkOn': 'लिंक चालू',
  'col.lists.empty': 'अभी कोई सूची नहीं',
  'col.lists.emptyHint': 'किसी विषय, आयोजन या पाठ्यक्रम के लिए शीर्षकों को समूहित करने हेतु पठन सूची बनाएँ।',
  'col.lists.noMatch': 'कोई सूची मेल नहीं खाती',
  'col.lists.noMatchHint': 'दूसरी खोज आज़माएँ या फ़िल्टर हटाएँ।',
  'col.lists.detailTitle': 'सूची विवरण',
  'col.lists.ownedBy': '{owner} द्वारा · {count} प्रविष्टियाँ',
  'col.lists.exportCsv': 'CSV निर्यात करें',
  'col.lists.exportIds': 'आईडी निर्यात करें',
  'col.lists.exportFailed': 'निर्यात विफल रहा',
  'col.lists.deleteConfirm': '"{name}" हटाएँ?',
  'col.lists.deleteHint': 'सूची और उसकी प्रविष्टियाँ हट जाएँगी। रिकॉर्ड कैटलॉग में बने रहेंगे।',
  'col.lists.deleted': 'सूची हटाई गई',
  'col.lists.deleteFailed': 'सूची नहीं हटाई जा सकी',
  'col.lists.share': 'साझा करना',
  'col.lists.shareLink': 'लिंक से साझा करें',
  'col.lists.shareHint': 'ऐसा लिंक चालू करें जिसे कोई भी बिना साइन इन खोल सके।',
  'col.lists.shareUrl': 'शेयर लिंक',
  'col.lists.shareFailed': 'साझा करना बदला नहीं जा सका',
  'col.lists.entries': 'प्रविष्टियाँ',
  'col.lists.addRecord': 'रिकॉर्ड जोड़ें',
  'col.lists.addRecordPlaceholder': 'शीर्षक जोड़ने के लिए कैटलॉग खोजें',
  'col.lists.noRecords': 'कोई रिकॉर्ड नहीं मिला',
  'col.lists.added': '"{title}" जोड़ा गया',
  'col.lists.addFailed': 'रिकॉर्ड नहीं जोड़ा जा सका',
  'col.lists.noEntries': 'यह सूची खाली है',
  'col.lists.noEntriesHint': 'पहला शीर्षक जोड़ने के लिए ऊपर कैटलॉग खोजें।',
  'col.lists.sortedBy': 'प्रविष्टियाँ {field} के अनुसार क्रमित हैं। उन्हें पुनर्व्यवस्थित करने हेतु संपादित करें में मैन्युअल क्रम चुनें।',
  'col.lists.moveUp': '{title} को ऊपर ले जाएँ',
  'col.lists.moveDown': '{title} को नीचे ले जाएँ',
  'col.lists.reorderFailed': 'नया क्रम सहेजा नहीं जा सका',
  'col.lists.note': 'टिप्पणी',
  'col.lists.notePlaceholder': 'इस शीर्षक के लिए टिप्पणी जोड़ें',
  'col.lists.editNote': 'टिप्पणी संपादित करें',
  'col.lists.noteFailed': 'टिप्पणी सहेजी नहीं जा सकी',
  'col.lists.removeEntry': '{title} को सूची से हटाएँ',
  'col.lists.removeConfirm': '"{title}" को इस सूची से हटाएँ?',
  'col.lists.removeFailed': 'प्रविष्टि नहीं हटाई जा सकी',
  'col.courses.title': 'पाठ्यक्रम आरक्षित सामग्री',
  'col.courses.subtitle': 'पाठ्यक्रम चलने तक अस्थायी ऋण नियमों के साथ सामग्री आरक्षित करें।',
  'col.courses.new': 'नया पाठ्यक्रम',
  'col.courses.newTitle': 'नया पाठ्यक्रम',
  'col.courses.editTitle': 'पाठ्यक्रम संपादित करें',
  'col.courses.detailTitle': 'पाठ्यक्रम आरक्षण',
  'col.courses.code': 'कोड',
  'col.courses.name': 'पाठ्यक्रम का नाम',
  'col.courses.department': 'विभाग',
  'col.courses.term': 'सत्र',
  'col.courses.section': 'अनुभाग',
  'col.courses.sectionN': 'अनुभाग {n}',
  'col.courses.startDate': 'प्रारंभ तिथि',
  'col.courses.endDate': 'समाप्ति तिथि',
  'col.courses.instructors': 'प्रशिक्षक',
  'col.courses.instructorsHint': 'सदस्यों को नाम या कार्ड नंबर से खोजें।',
  'col.courses.removeInstructor': '{name} को हटाएँ',
  'col.courses.noInstructors': 'कोई प्रशिक्षक नियुक्त नहीं',
  'col.courses.notes': 'टिप्पणियाँ',
  'col.courses.enabled': 'सक्रिय',
  'col.courses.disabled': 'निष्क्रिय',
  'col.courses.enabledSwitch': 'पाठ्यक्रम सक्रिय',
  'col.courses.enabledHint': 'सक्रिय करने पर अस्थायी सेटिंग लागू होती हैं। निष्क्रिय करने पर मूल सेटिंग लौट आती हैं।',
  'col.courses.enableCourse': 'पाठ्यक्रम {code} सक्रिय करें',
  'col.courses.itemCount': 'सामग्री',
  'col.courses.search': 'कोड, नाम, विभाग या प्रशिक्षक से खोजें',
  'col.courses.empty': 'अभी कोई पाठ्यक्रम नहीं',
  'col.courses.emptyHint': 'पाठ्यक्रम बनाएँ, फिर उसकी आरक्षित सूची में सामग्री स्कैन करें।',
  'col.courses.noMatch': 'कोई पाठ्यक्रम मेल नहीं खाता',
  'col.courses.noMatchHint': 'दूसरी खोज आज़माएँ या फ़िल्टर हटाएँ।',
  'col.courses.saved': 'पाठ्यक्रम सहेजा गया',
  'col.courses.created': 'पाठ्यक्रम बनाया गया',
  'col.courses.toggleFailed': 'पाठ्यक्रम की स्थिति बदली नहीं जा सकी',
  'col.courses.deleteConfirm': 'पाठ्यक्रम "{name}" हटाएँ?',
  'col.courses.deleteHint': 'इसके द्वारा बदली गई हर सामग्री मूल सेटिंग पर लौट आएगी।',
  'col.courses.deleted': 'पाठ्यक्रम हटाया गया',
  'col.courses.deleteFailed': 'पाठ्यक्रम नहीं हटाया जा सका',
  'col.courses.items': 'आरक्षित सामग्री',
  'col.courses.scanLabel': 'बारकोड से सामग्री जोड़ें',
  'col.courses.scanPlaceholder': 'सामग्री का बारकोड स्कैन करें या लिखें',
  'col.courses.overridesToggle': 'अगली सामग्री के लिए अस्थायी सेटिंग',
  'col.courses.overridesHint': 'ये सेटिंग केवल पाठ्यक्रम सक्रिय रहने तक सामग्री पर लागू होती हैं।',
  'col.courses.noOverride': 'वर्तमान रखें',
  'col.courses.tempType': 'सामग्री प्रकार',
  'col.courses.tempLocation': 'शेल्फ़ स्थान',
  'col.courses.tempCollection': 'संग्रह',
  'col.courses.tempLibrary': 'धारक पुस्तकालय',
  'col.courses.tempCallNumber': 'कॉल नंबर',
  'col.courses.staffNote': 'स्टाफ़ टिप्पणी',
  'col.courses.publicNote': 'सार्वजनिक टिप्पणी',
  'col.courses.itemAdded': '"{title}" आरक्षित की गई',
  'col.courses.noAuthor': 'लेखक नहीं',
  'col.courses.applied': 'लागू',
  'col.courses.pending': 'लागू नहीं',
  'col.courses.itemOff': 'बंद',
  'col.courses.itemEnabled': '{title} के लिए आरक्षण सक्रिय',
  'col.courses.editItem': 'अस्थायी सेटिंग संपादित करें',
  'col.courses.itemSaveFailed': 'सामग्री सहेजी नहीं जा सकी',
  'col.courses.removeItem': '{title} को आरक्षण से हटाएँ',
  'col.courses.removeItemConfirm': '"{title}" को आरक्षण से हटाएँ?',
  'col.courses.removeItemHint': 'इसकी मूल सेटिंग बहाल हो जाएँगी।',
  'col.courses.itemRemoveFailed': 'सामग्री नहीं हटाई जा सकी',
  'col.courses.noItems': 'अभी कुछ आरक्षित नहीं',
  'col.courses.noItemsHint': 'इस पाठ्यक्रम में आरक्षित करने हेतु ऊपर सामग्री का बारकोड स्कैन करें।',
  'col.reviews.title': 'समीक्षाएँ और टैग',
  'col.reviews.subtitle': 'कैटलॉग में दिखने से पहले शीर्षकों पर सदस्यों के लिखे को मॉडरेट करें।',
  'col.reviews.tab': 'समीक्षाएँ',
  'col.reviews.queue': 'समीक्षा मॉडरेशन कतार',
  'col.reviews.status.pending': 'लंबित',
  'col.reviews.status.approved': 'स्वीकृत',
  'col.reviews.status.rejected': 'अस्वीकृत',
  'col.reviews.status.all': 'सभी',
  'col.reviews.kbdMove': 'चलें',
  'col.reviews.kbdApprove': 'स्वीकृत',
  'col.reviews.kbdReject': 'अस्वीकृत',
  'col.reviews.approve': 'स्वीकृत करें',
  'col.reviews.reject': 'अस्वीकार करें',
  'col.reviews.select': '{name} की समीक्षा चुनें',
  'col.reviews.bulk': 'सामूहिक कार्य',
  'col.reviews.deleteOne': 'समीक्षा हटाएँ',
  'col.reviews.deleteConfirm': '{count} समीक्षा हटाएँ?',
  'col.reviews.deleteHint': 'इसे पूर्ववत नहीं किया जा सकता।',
  'col.reviews.queueClear': 'कतार खाली है',
  'col.reviews.queueClearHint': 'सदस्यों की नई समीक्षाएँ अनुमोदन के लिए यहाँ दिखेंगी।',
  'col.reviews.empty': 'यहाँ कोई समीक्षा नहीं',
  'col.reviews.emptyHint': 'दूसरी स्थिति चुनें।',
  'col.reviews.done.approve': '{count} समीक्षा स्वीकृत',
  'col.reviews.done.reject': '{count} समीक्षा अस्वीकृत',
  'col.reviews.done.delete': '{count} समीक्षा हटाई गई',
  'col.reviews.actionFailed': '{count} समीक्षा अद्यतन नहीं हो सकी',
  'col.tags.tab': 'टैग',
  'col.tags.title': 'टैग मॉडरेशन',
  'col.tags.term': 'टैग',
  'col.tags.record': 'रिकॉर्ड',
  'col.tags.patron': 'जोड़ने वाला',
  'col.tags.created': 'बनाया गया',
  'col.tags.visible': 'दृश्य',
  'col.tags.hidden': 'छिपा',
  'col.tags.hide': 'छिपाएँ',
  'col.tags.approveSelected': 'चयनित स्वीकृत करें',
  'col.tags.search': 'टैग खोजें',
  'col.tags.deleteOne': 'टैग {term} हटाएँ',
  'col.tags.deleteConfirm': '{count} टैग हटाएँ?',
  'col.tags.queueClear': 'कोई टैग प्रतीक्षा में नहीं',
  'col.tags.queueClearHint': 'सदस्यों के सुझाए टैग अनुमोदन के लिए यहाँ दिखते हैं।',
  'col.tags.empty': 'कोई टैग नहीं मिला',
  'col.tags.emptyHint': 'दूसरा फ़िल्टर आज़माएँ।',
  'col.tags.done.approve': '{count} टैग स्वीकृत',
  'col.tags.done.reject': '{count} टैग छिपाए गए',
  'col.tags.done.delete': '{count} टैग हटाए गए',
  'col.tags.actionFailed': '{count} टैग अद्यतन नहीं हो सके',
  'col.tags.cloud': 'सार्वजनिक टैग क्लाउड',
  'col.tags.cloudHint': 'स्वीकृत टैग जैसा सदस्य देखते हैं। बड़ा मतलब अधिक उपयोग।',
  'col.tags.cloudEmpty': 'अभी कोई स्वीकृत टैग नहीं',
  'col.tags.cloudCount': '{count} बार उपयोग',
};
